import { IFieldValue } from '../types/IFieldValue';
import { IFieldValuesParams } from '../types/IFieldValuesParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetFieldValuesResult extends IGetItemsResult {
  fieldValues: IFieldValue[];
}

export class GetFieldValuesRequest extends Request<IFieldValuesParams, IGetFieldValuesResult> {
  constructor(params: IFieldValuesParams) {
    super('getFieldValues', params);
  }
}

export class GetFieldValuesForMixedContentRequest extends Request<IFieldValuesParams, IGetFieldValuesResult> {
  constructor(params: IFieldValuesParams) {
    super('getFieldValuesForMixedContent', params);
  }
}
